// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./CircleCheckIcon.data";

export const CircleCheckIcon = createIcon("CircleCheckIcon", iconNode);
